import React, { Component } from 'react'
import { connect } from 'react-redux'

class MethodsOfMCP extends Component {
    renderIntegrationTool() {
        return null
    }

    renderDocument() {
        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>Methods of Processing MCP Transactions</b></span>
                <p style={{marginTop: '3vh'}}>There are two methods of processing multi-currency pricing transactions via the Moneris Gateway:</p>
                <ol>
                    <li><span style={{color: '#00a1cb', fontWeight: '600'}}>Using the MCP Get Rate transaction</span> – this method is used to obtain a foreign exchange rate and locks that specific rate in for a limited time, and is applied in a subsequent transaction</li>
                    <li style={{marginTop: '2vh'}}><span style={{color: '#00a1cb', fontWeight: '600'}}>Without using MCP Get Rate</span> – this method sends a MCP transaction without performing the Get Rate request, and the foreign exchange rate is obtained at processing time</li>
                </ol>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode };
}

export default connect(mapStateToProps, {})(MethodsOfMCP)
